// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__393AN","actionsCol":"EnrolledClinics_actionsCol__3jCf-"};